import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  @media screen and (max-width: 960px) {
    align-items: flex-start;
    .title {
      max-width: 320px !important;
      padding-right: 23px;
    }
  }

  .title {
    width: 100%;
    max-width: 400px;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    color: ${(props) => props.theme.colors.black};
    line-height: 19.2px;
  }

  .attendanceDiv {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 14px;
    font-weight: bold;
    color: ${(props) => props.theme.colors.gray};
    margin-top: 24px;

    .fix {
      margin-bottom: 4px;
    }

    .attendance {
      margin-top: 4px;
      font-size: 16px;
      font-weight: 400;
      line-height: 20, 8px;
      color: ${(props) => props.theme.colors.gray};
    }
  }

  .btns_receivecall {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-top: 24px;

    button {
      width: 100% !important;
    }

    p {
      padding: 0 8px;
      font-size: 16px;
      color: ${(props) => props.theme.colors.white};
    }
  }
`;
